import { FC } from 'react';
import { AllieIconProps } from '../../../components';

export const SendIcon: FC<AllieIconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    {...props}
  >
    <path
      // eslint-disable-next-line max-len
      d="M8.75036 10.5999H4.16702M4.09648 10.8428L2.15071 16.6551C1.99785 17.1117 1.92142 17.34 1.97627 17.4806C2.0239 17.6027 2.1262 17.6953 2.25244 17.7305C2.3978 17.7711 2.61736 17.6723 3.05647 17.4747L16.9827 11.2079C17.4113 11.015 17.6256 10.9186 17.6918 10.7846C17.7494 10.6682 17.7494 10.5316 17.6918 10.4153C17.6256 10.2813 17.4113 10.1848 16.9827 9.99198L3.05161 3.72303C2.61383 3.52602 2.39493 3.42752 2.24971 3.46793C2.1236 3.50302 2.0213 3.59534 1.97351 3.71721C1.91847 3.85754 1.99408 4.08535 2.14531 4.54098L4.09702 10.4212C4.12299 10.4995 4.13598 10.5386 4.14111 10.5786C4.14565 10.6141 4.14561 10.6501 4.14097 10.6856C4.13574 10.7256 4.12265 10.7647 4.09648 10.8428Z"
      stroke="white"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
